<template>
  <div class="label-option">
    <div class="label" v-show="label">{{ label }}</div>
    <div class="select-box" :style="{ width }">
      <div style="float: right">
        <slot />
      </div>
      <a-select
        @change="handleSelectChange"
        :value="allowEmpty ? value : value || optionList[0].value"
        :disabled="disabled"
        :loading="loading"
        size="small"
        :options="displayOptions"
        class="select-box__select"
        :dropdownMatchSelectWidth="dropdownMatchSelectWidth"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "LabelOption",
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    label: {
      default: function () {
        return ''
      }
    },
    optionList: {
      default: function () {
        return [{ name: '1', value: '1' }]
      }
    },
    handleChange: {
      default: function () {
        return function () {
        }
      }
    },
    width: {
      default: function () {
        return '138px'
      }
    },
    value: {
      default() {
        return null
      }
    },
    disabled: Boolean,
    loading:Boolean,
    allowEmpty: Boolean,
    dropdownMatchSelectWidth: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    displayOptions() {
      return this.optionList && this.optionList.map(op => ({
        value: op.value,
        label: op.name,
        disabled: op.disabled
      }));
    }
  },
  methods: {
    handleSelectChange(e) {
      this.handleChange(e);
      this.$emit('change', e);
    }
  }
}
</script>

<style scoped>
.label-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}

.label {
  font-size: 12px;
  font-weight: 400;
}

.select-box,
.select-box__select {
  overflow: hidden;
}

.select-box__select {
  display: block;
}
</style>

<style>
.label-option .ant-select-selection {
  height: 25px;
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  border: 1px solid rgba(229, 229, 231, 1);
  color: rgba(101, 102, 103, 1);
  font-size: 12px;
}

.label-option .ant-select-disabled {
  opacity: 0.4;
}
</style>
